var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","d":"m2.989 13.03 5.01-5.01m5.01-5.01L8 8.02m0 0 5.018 5.018M8 8.018l-5.01-5.01"}})])
}
var staticRenderFns = []

export default { render: render }